// convert all the code from vue2 to vue3
// https://next.vuex.vuejs.org/guide/migrating-to-4-0-from-3-x.html

// store.ts
import Vue from "vue";
import Vuex from "vuex";
import {
  DischargeLoadSequencingResponse,
  DischargeLoadSequencingRequest,
  Detail,
  VesselHatch
} from "./DischargeLoadSequencing.types";
import ApiService from "../api.service";
import { cond } from "lodash";
const SET_ERROR = "setError";

Vue.use(Vuex);

interface State {
  errors: string[];
  loadingMessage: string;
  isStowagInstructionLoading: boolean[];
  DischargeLoadSequencingResponse: DischargeLoadSequencingResponse;
  DischargeLoadSequencingRequest: DischargeLoadSequencingRequest;
  DischargeLoadSequencingVoyageContainersData: any;
  isDischargeLoadSequencingDetailModalOpen:boolean
}

const state = {
  errors: [],
  loadingMessage: "loading",
  isStowagInstructionLoading: [],
  StowagInstructionRequest: {},
  StowagInstructionResponse: {},
  DischargeLoadSequencingVoyageContainersData: null,
  isDischargeLoadSequencingDetailModalOpen:false
};


const getters = {
  getDischargeLoadSequencingErrors() {
    return state.errors;
  },
   getDischargeLoadSequencingVoyageContainersData: function(state: State) {
    return state.DischargeLoadSequencingVoyageContainersData;
  } ,
  getDischargeLoadSequencingVoyageContainersDetail: function(state: State) {
    if(state.DischargeLoadSequencingVoyageContainersData)
    return state.DischargeLoadSequencingVoyageContainersData.detail;
  } ,
  getIsDischargeLoadSequencingLoading: function(state: State) {
    return state.isDischargeLoadSequencingDetailModalOpen;
  },
  
};

const actions = {
  async fetchdischargeloadsequencingvoyagecontainerslist({ commit, state: State }, payload) {
    //commit("isDischargeLoadSequencingLoadingMutation", true);
    return new Promise((resolve) => {
      ApiService.post("system/dischargeloadsequencing/getvoyagecontainerslist", {
       ...payload
      })
        .then((response) => {
          if (response.data.isSuccessful) {
            commit("DischargeLoadSequencingVoyageContainersData", response.data.data);
          } else {
            commit(SET_ERROR, response.data.message);
          }
          resolve(response);
        })
        .finally(() => {
         commit("isStowagInstructionLoadingMutation", false);
        });
    });
  }
};

const mutations = {
  DischargeLoadSequencingVoyageContainersData(state: State, payload: any) {
    state.DischargeLoadSequencingVoyageContainersData = payload;
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
